import React from 'react';
import { useSelector } from 'react-redux';
import classes from './RunningLine.module.css';
import { useTranslation } from 'react-i18next';
import circle from '../../images/svg/circle-carousel.svg';
import { selectServicePrices } from '../../PlatformConfig/store/selectors';

export default function RunningLineItem() {
  const { t } = useTranslation();
  const servicePrices = useSelector(selectServicePrices);
  const thresholdEuro = servicePrices?.shippingExemptionThreshold != null ? servicePrices.shippingExemptionThreshold / 100 : 145;

  return (
    <>
      <li className={classes.runningItem}>
        <img src={circle} alt='' />
        {t('DorToDoor')}
      </li>
      <li className={classes.runningItem}>
        <img src={circle} alt='' />
        {t('GermanAustriaShiping')}
      </li>
      <li className={classes.runningItem}>
        <img src={circle} alt='' />
        {t('FreeTransport', { threshold: thresholdEuro })}
      </li>
      <li className={classes.runningItem}>
        <img src={circle} alt='' />
        {t('TypicalRepairTime')}
      </li>
    </>
  );
}
